import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import { ContainerButton, Link } from "@examspark/common-ui";
import {
  CardLink,
  LinkCard,
} from "@examspark/common-ui/dist/components/containers/LinkCard";
import Icon from "@examspark/common-ui/dist/components/icons/Icon";
import { colorFromTheme } from "@examspark/common-ui/dist/utils/color";

export const BasicSidebarList = styled.div``;

const Styled = styled.div`
  display: flex;
  padding: 1rem 1rem;
  border-top: solid 1px #e2e2e2;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  align-items: start;

  svg {
    fill: #bbb;
    display: block;
    width: 24px;
  }

  &:hover a {
    text-decoration: underline;
  }
`;

const StyledIcon = styled.div`
  width: 3rem;
`;

const BasicSidebarListItem = (
  props: PropsWithChildren<{
    icon: React.ReactNode;
    onClick?: () => void;
  }>,
) => {
  return (
    <Styled onClick={props.onClick}>
      {!!props.icon && <StyledIcon>{props.icon}</StyledIcon>}
      <div style={{ flex: "1" }}>
        <div
          style={{ display: "flex", alignItems: "center", minHeight: "2.4rem" }}
        >
          <Link>{props.children}</Link>
        </div>
      </div>
    </Styled>
  );
};

export default BasicSidebarListItem;

export const SidebarLinkItem = styled(LinkCard)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  border: none;
  border-radius: 0px;
  box-shadow: 0px 0px 0px 1px #ddd;
  background-color: white;

  &:last-child {
    border-radius: 0 0 0.5rem 0.5rem;
  }

  & > ${Icon} {
    flex-shrink: 0;
  }

  &:hover ${CardLink} {
    text-decoration: underline;
  }

  ${CardLink} {
    flex-grow: 1;
  }

  &:hover {
    background-color: ${colorFromTheme("surface3")};
  }
`;

export const SidebarButtonItem = styled(ContainerButton)`
  width: 100%;
  text-align: center;
  color: hsl(250, 48%, 53%, 1);
  padding: 1rem;
  transition: background-color 0.2s ease-in-out;

  border-radius: 0 0 0.5rem 0.5rem;

  &:disabled {
    color: hsl(250, 48%, 53%, 0.5);
    cursor: not-allowed;
  }

  &:hover {
    background-color: ${colorFromTheme("surface3")};
    text-decoration: underline;
  }

  &:last-child {
    border-radius: 0 0 0.5rem 0.5rem;
  }
`;
